import { render, staticRenderFns } from "./swiper.tpl.vue?vue&type=template&id=14ea42a4&scoped=true&lang=html&name=Swiper&"
import script from "./swiper.js?vue&type=script&lang=js&"
export * from "./swiper.js?vue&type=script&lang=js&"
import style0 from "./swiper.styl?vue&type=style&index=0&id=14ea42a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ea42a4",
  null
  
)

export default component.exports